import { useQueryClient } from '@tanstack/react-query'
import { useAuth as useOidcAuth } from 'react-oidc-context'
import { clearAuthErrorState } from './auth-error-store'
import { performLogout } from './logout'

const AUTH_ME_QUERY_KEY = ['auth', 'me'] as const

/**
 * Explicit Cognito logout adapter (ADR-0011). Ordering is fixed:
 * (1) clear Atlas current-user/auth-error query state → (2) best-effort local OIDC
 * cleanup → (3) remove the provider-owned OIDC user → (4) redirect to the Cognito
 * Hosted UI `/logout`, built ONLY from validated config. Local cleanup happens
 * before navigation so it still occurs if the hosted logout request fails; missing
 * config fails closed (local cleanup, no redirect).
 */
export function useLogout(): () => void {
	const oidc = useOidcAuth()
	const queryClient = useQueryClient()

	return () => {
		void performLogout({
			clearSession: async () => {
				clearAuthErrorState()
				queryClient.removeQueries({ queryKey: AUTH_ME_QUERY_KEY })
				try {
					await oidc.removeUser()
				} catch {
					// best-effort local cleanup before navigation
				}
			},
			redirect: (url) => {
				window.location.assign(url)
			},
		})
	}
}
